import { createCRUDConstants } from "../../../utils/redux.utils";

export const nameSpace = "INSTITUTION"
export const institutionConstants = createCRUDConstants(nameSpace);

export const name_space = "INSTITUTION-DROPDOWN"
export const institutionDropdownConstants = createCRUDConstants(name_space);

export const nameFepSpace = "INSTITUTION-FEP"
export const institutionFEPConstants = createCRUDConstants(nameFepSpace);
